import CancelWarning from './cancel-warning/PopupCancelWarning';
import CodesParser from './codes-parser/CodesParserPopup';
import DeleteWarning from './delete-warning/PopupDeleteWarning';
import Form from './form/PopupForm';
import StatementUpload from './statement-upload/PopupStatementUpload';
import WatchlistImport from './watchlist-import/PopupWatchlistImport';
import WarningPopup from './warning-popup/WarningPopup';
import YoutubeMagelupAuthorize from './youtube-magelup-authorize/PopupYoutubeMagelupAuthorize';

export default {
  DeleteWarning,
  CancelWarning,
  Form,
  WarningPopup,
  CodesParser,
  StatementUpload,
  WatchlistImport,
  YoutubeMagelupAuthorize,
};
